import React, { Suspense, lazy, useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Header from "../Header";
import "../Body/Body.css";

// Lazy load the widget script
const WidgetScript = lazy(() => import('../ScriptTags/widget'));

export default function Body({ links }) {
  const imgCDNURL = process.env.REACT_APP_WORKSHOP_CDN_URL;
  
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 991.9);
  
  // Adjust screen size for responsive behavior
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 991.9);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const scrollToSignUpForm = () => {
    const signupForm = document.getElementById('ContactForm');
    if (signupForm) {
      signupForm.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Define the handlePlayClick function (can be used to open a video modal)
  const handlePlayClick = (e) => {
    e.preventDefault();
    // Logic for opening a video modal or playing the video
  };

  return (
    <>
      <div className="banner body-banner">
        <Header links={links} />
        
        {/* Conditional rendering for desktop or mobile video */}
        <video
          autoPlay
          muted
          preload="auto"
          loop
          playsInline
          id={`banner-video-${isDesktop ? 'desktop' : 'mobile'}`}
          className={`banner-${isDesktop ? 'deskvideo' : 'mobvideo'}`}
        >
          <source src={imgCDNURL + (isDesktop ? 'desktop.mp4' : 'mobile.mp4')} type="video/mp4" />
        </video>

        <Container className="bannercontainer">
          <Row>
            <div className="bannertext">
              <div className="bannerhead">
                <h2 className="free-heading">Free Lead Prospecting and Websites</h2>
                <h1 className="Workshop-heading">Workshops</h1>
                <h2 className="every-heading">every hour on the hour</h2>
              </div>
              <div>
                <Button className="SignupBtn body-signup" onClick={() => window.open('https://www.swmc.com/angelai/workshop', "_blank")}>
                  Sign up Now
                </Button>
              </div>
              <h2 className="boost-heading">Boost your business today with Ai</h2>
            </div>

            <Row className="workshop-details-section">
              <Col md={12} lg={6} sm={12}>
                <div className="workshop-text body-workshop-text">
                  <h6>Learn Hands-On with Expert</h6>
                  <h1>WORKSHOPS</h1>
                  <h3>Daily</h3>
                  <p>The workshops begin at the top of every hour, from 10:00 A.M. - 5:00 P.M. local time, on all business days.</p>
                </div>
              </Col>
              <Col md={12} lg={6} sm={12} className="workshopcard-section">
                <div className="workshopcard">
                  <p className="opportunity body-opportunity">
                    You won't want to miss this opportunity to finance on demand and embrace the rise of Ai. Our workshops bring speed, certainty, confidence, and truth to your financial commitments, allowing you to close fast and earn more.
                  </p>
                  <p className="power body-power">
                    Tap into the Power of Ai with {links.current.brandName} and Achieve More Than You Ever Imagined
                  </p>
                </div>
              </Col>
            </Row>
          </Row>
        </Container>
      </div>

      {/* Lazy load WidgetScript with Suspense fallback */}
      <Suspense fallback={<div>Loading Widget...</div>}>
        <WidgetScript />
      </Suspense>
    </>
  );
}
